import { useEffect, useState } from "react";
import api from "@/lib/api";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import MenuSection from "@/components/MenuSection";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import LocationHours from "@/components/LocationHours";
import Footer from "@/components/Footer";

export default function Home() {
  const [settings, setSettings] = useState(null);
  const [images, setImages] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/content/settings"),
      api.get("/content/hero-images"),
      api.get("/content/gallery-images"),
      api.get("/content/categories"),
      api.get("/content/menu-items"),
    ])
      .then(([s, h, g, c, m]) => {
        setSettings(s.data);
        setImages(h.data);
        setGallery(g.data);
        setCategories(c.data);
        setItems(m.data);
        if (s.data?.business_name) {
          document.title = `${s.data.business_name} | Jackson Township, NJ`;
        }
      })
      .catch((e) => console.error("Content fetch failed", e));
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-[var(--dough)]">
      <Nav settings={settings} />
      <Hero images={images} settings={settings} />
      <MenuSection categories={categories} items={items} settings={settings} />
      <Gallery images={gallery} settings={settings} />
      <About settings={settings} />
      <LocationHours settings={settings} />
      <Footer settings={settings} />
    </div>
  );
}
